import { IPoliticalPartyPagedRequest } from '../../../../model/sge/political-party/request/political-party-paged-request';

export type PoliticalPartySearchState = {
    parameters: IPoliticalPartyPagedRequest;
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
}

export const PoliticalPartySearchReducer = (state: PoliticalPartySearchState, action: any): PoliticalPartySearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
